import { render, staticRenderFns } from "./subprogram-nba-summary-start-playoffs-button.vue?vue&type=template&id=5a9fe010&"
import script from "./subprogram-nba-summary-start-playoffs-button.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-summary-start-playoffs-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports